import { render } from "./EditReminder.vue?vue&type=template&id=e8946cde"
import script from "./EditReminder.vue?vue&type=script&lang=js"
export * from "./EditReminder.vue?vue&type=script&lang=js"

import "./EditReminder.vue?vue&type=style&index=0&id=e8946cde&lang=css"
import "./EditReminder.vue?vue&type=style&index=1&id=e8946cde&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__